<template>
    <v-row no-gutters>
        <v-col cols="12"
            :style="'border-radius:5px 0 0 0;height:' + (height ? height : '100') + 'px;background-color:' + primaryColor">
        </v-col>
    </v-row>
</template>

<script>
export default {
    props: ["curriculumData", "height"],
    data() {
        return {
            primaryColor: null,
        }
    },
    created() {
        this.primaryColor = this.curriculumData.level;
        if (!this.curriculumData.useBelts && this.curriculumData.color)
            this.primaryColor = this.curriculumData.color;
    }
}
</script>

<style scoped></style>
